import React from 'react';
import { Badge, ListGroup, ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import { ValuesList } from '../Components/layout/ReviewRow';
import { hasAValue } from '../App';
import TestDriveSetupSidebar from './TestDriveSetupSidebar';
import { TEST_DRIVE_ACTIVITIES } from './ConstForTestDriveSection';
import { SUBTABS } from './ConstPaths';

// const propTypes = {
//   activeAccessMethodName: PropTypes.string,
//   activeSetupSelectionMethod: PropTypes.string,
//   activeSetupBodySite: PropTypes.arrayOf(PropTypes.string),
//   activeSetupAccessories: PropTypes.arrayOf(PropTypes.string),
//   activeSetupName: PropTypes.string,
// };

// const defaultProps = {
//   activeAccessMethodName: '',
//   activeSetupSelectionMethod: '',
//   activeSetupBodySite: [],
//   activeSetupAccessories: [],
//   activeSetupName: '',
// };

function shouldShowFullInfo(id, tdObj){
  // console.log("tdObj: " + JSON.stringify(tdObj));
  if(tdObj === null || tdObj === undefined){
    tdObj = {};
  }

  let showFullInfo = false;
  let valuesArray = Object.values(tdObj);
  let anyTdData = (valuesArray.some(hasAValue));

  if(id && anyTdData)
    showFullInfo = true;
  return(showFullInfo);
}

function TestDriveFullSidebar(props) {
  const {
    activeTestDrive,
    numTDs
  } = props;
  return(
    <ListGroup>
      <ListGroupItem>
        <strong>Current Test-drive</strong> <span className="fa fa-circle" aria-hidden="true" style={{ color: 'green'}}></span>
        <ListGroup flush>
          <TestDriveSetupSidebar 
            activeAccessMethodName={activeTestDrive.activeAccessMethodName}
            activeSetupSelectionMethod={activeTestDrive.activeSetupSelectionMethod}
            activeSetupBodySite={activeTestDrive.activeSetupBodySite}
            activeSetupAccessories={activeTestDrive.activeSetupAccessories}
            activeSetupName={activeTestDrive.activeSetupName}
          />
          <TestDriveActivitiesSidebar
            activities={activeTestDrive.activeTestDriveActivities}
          />
        </ListGroup>
      </ListGroupItem>
      <NumTestDrivesBadge numTDs={numTDs} />
    </ListGroup>
  )
} 
function TestDriveEmptySidebar(props) {
  const {
    numTDs
  } = props;

  return(
    <ListGroup>
      <ListGroupItem>
        <strong>Current Test-drive</strong> <span className="fa fa-circle-thin" aria-hidden="true" style={{ color: 'green'}}></span>
        <ListGroup className="aa-setup-sidebar" flush>
          <ListGroupItem>- empty -</ListGroupItem>
        </ListGroup>
      </ListGroupItem>
      <NumTestDrivesBadge numTDs={numTDs} />
    </ListGroup>
  )
} 
function NumTestDrivesBadge(props){
  return(
    <>
    { (props.numTDs) 
    ?
    <ListGroupItem>
      <Link to={SUBTABS.TEST_REVIEW}><strong>All Test-drives</strong></Link> <Badge color="primary">{props.numTDs}</Badge>
    </ListGroupItem>
    :
    <ListGroupItem>
      <strong>All Test-drives</strong> <Badge color="secondary">{props.numTDs}</Badge>
    </ListGroupItem>
    }
    </>
  )
}

function TestDriveActivitiesSidebar(props){
  const activities = props.activities;
  const numActivities = activities ? activities.length : 0;

  return(
    <>
    { (numActivities) 
      ?
      <>
      {/* <p className="aa-sidebar-heading">Activities Completed</p> */}
      <ListGroupItem>Activities Completed <Badge color="secondary">{numActivities}</Badge>
        <ListGroup className="aa-activities-list aa-setup-sidebar"flush>
          {activities.map((a, index) =>
            <ListGroupItem key={index} style={{border:0}} >
              {(a.type === TEST_DRIVE_ACTIVITIES.OWN_ACTIVITY && !a.name)
                ? 'Your own activity'
                : a.name
              }
            </ListGroupItem> 
          )}  
        </ListGroup>
      </ListGroupItem>
      </>
      :      
      // <p className="aa-sidebar-heading">No Activities</p>
      <ListGroupItem>No Activities</ListGroupItem>
    }
    </>
  )
}
function TestDriveDevSidebar(props) {
  const {
    activeTestDriveId,
    activeTestDrive,
    activeTestDriveActivityId,
    activeTestDriveActivities,
    completedTestDrives,
  } = props;

  const tdIdFrag = activeTestDriveId ? activeTestDriveId.slice(0,5) : '';
  const actIdFrag = activeTestDriveActivityId ? activeTestDriveActivityId.slice(0,5) : '';
  const numActivities = activeTestDriveActivities ? activeTestDriveActivities.length : 0;
  const numTDs = completedTestDrives ? completedTestDrives.length : 0;

  let showFullInfo = shouldShowFullInfo(activeTestDriveId, activeTestDrive);
  return (
    <>
    { (showFullInfo)
      ? <TestDriveFullSidebar activeTestDrive={activeTestDrive} numTDs={numTDs}/>
      : <TestDriveEmptySidebar numTDs={numTDs}/>
    }
    </>
    // <>
    // <p className="aa-sidebar-heading">Test drive vars</p>
    // <ListGroup className="aa-setup-sidebar"flush>
    //   <ListGroupItem>activeTestDriveId
    //     <ValuesList 
    //       values={tdIdFrag} lookup={null} skipWarning
    //     />
    //   </ListGroupItem>
    //   <ListGroupItem>activeTDActivityId
    //     <ValuesList 
    //       values={actIdFrag} lookup={null} skipWarning
    //     />
    //   </ListGroupItem>
    //   <ListGroupItem># of activities
    //     <ValuesList 
    //       values={String(numActivities)} lookup={null} skipWarning
    //     />
    //   </ListGroupItem>
    //   <ListGroupItem>completed TDs
    //    <ValuesList 
    //       values={String(numTDs)} lookup={null} skipWarning
    //     />
    //   </ListGroupItem>
    // </ListGroup>
    // </>
  );
}

export default TestDriveDevSidebar;
